import { useNavigate } from "react-router-dom";
import {
    getSelectedSearchOrderType,
    getSelectedTabListView,
    getStoreLocalData,
    getUserData,
    setSelectedSearchOrderType,
    setSelectedTabListView,
} from "../../utils/localStorage";
import { ProgressSpinner } from "primereact/progressspinner";
import SchedularModal from "../SchedularModal";
import StatusFilterModal from "../StatusFilterModal";
import { useEffect, useRef, useState } from "react";
import { formatDate, formatDateNew, localeDateEndDate, localeDateStartDate } from "../../constants/DateUtil/DateUtil";
import { Accordion, AccordionTab } from "primereact/accordion";

import { DataScroller } from "primereact/datascroller";
import { Button } from "primereact/button";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import TabMenu from "../TabMenu";
import { Checkbox } from "primereact/checkbox";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import ButtonLink from "../../ButtonLink";
import { getBrandStore } from "../../services/StoreUsers/PostStoreUsers";
import StoreSelectionModal from "../StoreSelectionModal";
import AdminMenu from "../AdminMenu";
import { B2BChallanWithPaginationAndSearch } from "../../services/StoreOrder/StoreOrder";
import useB2BChallan from "../StoreContext/useB2BChallan";

const { innerWidth: width, innerHeight: height } = window;

const Orders = () => {
    const navigate = useNavigate();

    const { userProfileRole, brandProfileData } = getUserData();
    const { storeLocalData } = getStoreLocalData();

    const userRole = userProfileRole;
    let brandId = brandProfileData.id;

    const [schedularModalVisible, setSchedularModalVisible] = useState(false);
    const [statusFilterModalVisible, setStatusFilterModalVisible] =
        useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingSearch, setLoadingSearch] = useState(false);
    const [visible, setVisible] = useState(false);
    const [storeSelectionModalVisible, setStoreSelectionModalVisible] =
        useState(false);
    const [brandStoreIdsData, setBrandStoreIdsData] = useState([]);
    const [brandStoreData, setBrandStoreData] = useState([]);

    const {
        schedularDate,
        setSchedularDate,
        selectedStatus,
        setSelectedStatus,
        customerALLOrdersData,
        setCustomerALLOrdersData,
        statusTotalData,
        setStatusTotalData,
        sumOfGrandTotal,
        setSumOfGrandTotal,
        sumOfOrderCount,
        setSumOfOrderCount,
        upDateSelectedStatus,
        setUpDateSelectedStatus,
        page,
        setPage,
        // searchTerm,
        // setSearchTerm,
        useEffectCall,
        setUseEffectCall,
        homeDeliveryValue,
        setHomeDeliveryValue,
        urgentDeliveryValue,
        setUrgentDeliveryValue,
        selectedStore,
        setSelectedStore,
        upDateSelectedStore,
        setUpDateSelectedStore,
    } = useB2BChallan();

    const [searchTerm, setSearchTerm] = useState("");
    const [searchTermClean, setSearchTermClean] = useState(false);
    const [searchFilterValue, setSearchFilterValue] = useState("invoice");
    const [searchTypeToggle, setSearchTypeToggle] = useState(false);

    const initializeVariable = () => {
        setCustomerALLOrdersData([]);
        updateStatusTotals([]);
    };

    const handleCalendarModal = () => {
        setSchedularModalVisible(true);
    };

    const handleFilterModal = () => {
        setStatusFilterModalVisible(true);
        // Close the filter modal or perform any other necessary actions
    };

    // const [schedularDate, setSchedularDate] = useState({});
    const receiveDataFromSchedularModal = ({ newSchedular }) => {
        setUseEffectCall(true);
        setPage(0);
        setSchedularDate(newSchedular);
    };

    const receiveDataFromStatusFilterModal = (selectedStatus) => {
        setUseEffectCall(true);
        setPage(0);
        setSelectedStatus(selectedStatus);
    };

    const receiveDataFromStoreSelectionModal = (selectedStore) => {
        setUseEffectCall(true);
        setPage(0);
        setSelectedStore(selectedStore);
    };

    let initialStartDate = new Date();
    initialStartDate.setDate(initialStartDate.getDate() - 30); // subtract 7 days to current date

    // If orderFilterData is available, use its start and end dates
    const [startDate, setStartDate] = useState(new Date(initialStartDate));
    let initialEndDate = new Date();
    const [endDate, setEndDate] = useState(new Date(initialEndDate));

    const [isEndReached, setIsEndReached] = useState(false);
    const ds = useRef(null);

    const fetchStoreOrders = (data) => {
        setLoading(true);
        B2BChallanWithPaginationAndSearch({
            ...data,
            limit: 100,
            offset: page * 100, // Ensure offset is correctly applied
        })
            .then((response) => {
                if (!response.data.error) {
                    const Res = response.data;                     
                    if (page === 0) {
                        setCustomerALLOrdersData(Res);
                        updateStatusTotals(Res);
                    } else {
                        setCustomerALLOrdersData((prevData) => {
                            const existingIds = new Set(prevData.map((item) => item.id));
                            const newUniqueData = Res.filter(
                                (item) => !existingIds.has(item.id)
                            );
                            const updatedData = [...prevData, ...newUniqueData];

                            updateStatusTotals(updatedData); // Use combined, de-duped data
                            return updatedData;
                        });
                    }

                    setLoading(false);
                    setLoadingSearch(false);
                    setSearchTermClean(false);
                    setIsEndReached(Res.length < 100);
                }
            })
            .catch((err) => {
                console.error("Error:", err);
                setLoading(false);
                setLoadingSearch(false);
                setSearchTermClean(false);
            });
    };

    // for all status and one week data or by default data;
    const data = {
        storeIds: brandStoreIdsData,
        brandId: brandId,
        statusIn: ['BOOKED',
            'PROCESSED',
            'DELIVERED',
            'ORDERED',
            'CANCEL'],
        storeCustomerIds: [],
        storeUserIds: []
    };
    const [requestData, setRequestData] = useState(data);

    useEffect(() => {
        if (useEffectCall) {
            initializeVariable();
            if (selectedStatus !== "ALL") {
                requestData.statusIn = selectedStatus;
            } else {
                requestData.statusIn = ['BOOKED',
                    'PROCESSED',
                    'DELIVERED',
                    'ORDERED',
                    'CANCEL'];
            }
            if (selectedStore !== "ALL") {
                requestData.storeIds = selectedStore;
            } else {
                requestData.storeIds = brandStoreIdsData;
            }
            requestData.startDate = schedularDate?.startDate
                ? localeDateStartDate(new Date(schedularDate.startDate))
                : localeDateStartDate(new Date(startDate));
            requestData.endDate = schedularDate?.endDate
                ? localeDateEndDate(new Date(schedularDate.endDate))
                : localeDateEndDate(new Date(endDate));
            setPage(0);
            fetchStoreOrders(requestData);
        }
    }, [schedularDate, selectedStatus, searchTermClean, selectedStore]);

    useEffect(() => {
        getBrandStore(brandId)
            .then((response) => {
                if (!response.data.error) {
                    const Res = response.data;
                    const storeIds = Res.map((item) => item.id);
                    const data = {
                        storeIds: storeIds,
                    };
                    if (selectedStore !== "ALL") {
                        requestData.storeIds = selectedStore;
                    } else {
                        requestData.storeIds = storeIds;
                    }
                    fetchStoreOrders(requestData);
                    setUpDateSelectedStatus([]);
                    setUpDateSelectedStore([]);
                }
            })
            .catch((err) => {
                console.error("Error:", err);
            });
        fetchSelectedSearchType();
    }, []);

    useEffect(() => {
        getBrandStore(brandId)
            .then((response) => {
                if (!response.data.error) {
                    const Res = response.data;
                    const storeIds = Res.map((item) => item.id);
                    const data = {
                        storeIds: storeIds,
                    };
                    setBrandStoreData(Res);
                    setBrandStoreIdsData(storeIds);
                    //  fetchStoreOrderDashboard(data);
                }
            })
            .catch((err) => {
                console.error("Error:", err);
            });
    }, []);


    useEffect(() => {
        // fetchStoreOrders(data);
        fetchSelectedSearchType();
        fetchSelectedTabListView();
    }, []);

    const fetchSelectedSearchType = async () => {
        const selectedSearchTypeData = await getSelectedSearchOrderType();
        if (selectedSearchTypeData.searchOrderType !== null) {
            setSearchFilterValue(selectedSearchTypeData.searchOrderType);
        } else {
            setSearchFilterValue("");
        }
    };

    useEffect(() => {
        const requestValue = {
            ...requestData,
            searchBy: searchFilterValue !== "" ? searchFilterValue : "invoice",
            searchText: searchTerm,
        };
        if (page > 0) fetchStoreOrders(requestValue);
    }, [page]);

    

    const searchTermApiCall = () => {
        if (searchTerm !== "") {
            setLoadingSearch(true);
            setPage(0);
            const requestValue = {
                // ...requestData,
                storeIds: brandStoreIdsData,
                brandId: brandId,
                statusIn: ['BOOKED',
                    'PROCESSED',
                    'DELIVERED',
                    'ORDERED',
                    'CANCEL'],
                startDate: null,
                endDate: null,
                offset: 0,
                searchBy: searchFilterValue !== "" ? searchFilterValue : "invoice",
                searchText: searchTerm,
            };
            fetchStoreOrders(requestValue);
        } else {
            setSearchTerm("");
            setLoadingSearch(true);
            setUseEffectCall(true);
            setPage(0);
            setSearchTermClean(true);
        }
    };

    const getData = () => {
        if (!isEndReached && !loading) {
            setPage((prevPage) => prevPage + 1);
            ds.current.load();
        }
    };

    // Update status totals based on fetched data
    const updateStatusTotals = (orders) => {
        const statusTotals = orders.reduce((acc, order) => {
            const existingStatus = acc.find((item) => item.status === order.status);

            if (existingStatus) {
                existingStatus.grandTotalSum += order.grandTotal;
                existingStatus.orderCount += 1;
            } else {
                acc.push({
                    status: order.status,
                    grandTotalSum: order.grandTotal,
                    orderCount: 1,
                });
            }
            return acc;
        }, []);

        const totalGrandTotalSumData = statusTotals.reduce(
            (acc, item) => acc + item.grandTotalSum,
            0
        );
        const totalOrderCountData = statusTotals.reduce(
            (acc, item) => acc + item.orderCount,
            0
        );

        setStatusTotalData(statusTotals);
        setSumOfGrandTotal(totalGrandTotalSumData);
        setSumOfOrderCount(totalOrderCountData);
    };

    const handleSearchFilterChange = async (selectedItem) => {
        setSearchFilterValue(selectedItem);
        handleSearchType();
        await setSelectedSearchOrderType(selectedItem);
    };

    const FilterList = [
        {
            name: "By Challan",
            value: "challan",
        },
        {
            name: "By Invoice No.",
            value: "invoice",
        },
        {
            name: "By Order",
            value: "order",
        },
    ];

    const handleSearchType = () => {
        setSearchTypeToggle(!searchTypeToggle);
    };

    const handleClearSearch = () => {
        setSearchTerm("");
        setLoadingSearch(true);
        setUseEffectCall(true);
        setPage(0);
        setSearchTermClean(true);
    };

    const OrderStatusColors = {
        BOOKED: "#3EB3E1",
        PROCESSED: "#F5C43A",
        DELIVERED: "#09B4AA",
        ORDERED: "#55BD5A",
        CANCEL: "#FF6767",
        DEFAULT: "#000",
    };

    const renderPaymentModeButtons = () => {
        return statusTotalData.map((item) => (
            <div
                key={item.status}
                style={{ backgroundColor: OrderStatusColors[item.status] }}
                className="px-3 py-2 border-round-md"
            >
                <p className="text-white text-lg font-bold uppercase">
                    {item.orderCount} - {item.status.replace(/_/g, " ")} ({storeLocalData?.currencySymbol}{" "}
                    {item.grandTotalSum.toFixed(0)})
                </p>
            </div>
        ));
    };

    const itemTemplate = (data) => {
        const orderStatusColor =
            OrderStatusColors[data.status] || OrderStatusColors.DEFAULT;
        const displayDate =
            data.status === "DELIVERED" || data.status === "DONE"
                ? data.deliveredOn
                : data.deliveryOn;
        const displayBalanceText = data.status === "DELIVERED" ? "| Balance" : "";
        const displayBalanceAmount =
            data.status === "DELIVERED" ? "| " + data.balanceAmount : "";
        const displayDeliveryDateText =
            data.status === "DELIVERED" || data.status === "DONE"
                ? "Delivered On"
                : "Delivery Date";
        const formattedCreatedDate = formatDateNew(data.createdDate);
        const formattedDeliveryDate = formatDateNew(displayDate);

        return (
            <Accordion>
                <AccordionTab
                    key={data.id || data.challanNo || data.orderNo} // Use a more unique key like data.id
                    style={{
                        "--backgroundColor-AccordionTab": orderStatusColor,
                    }}
                    header={`${data.challanNo || "N/A"
                        } | ${formattedCreatedDate} ${data.status.replace(
                            /_/g,
                            " "
                        )}  -> ( DD - ${formattedDeliveryDate} | ${data.customerName || "N/A"
                        } | ${storeLocalData?.currencySymbol} ${data.grandTotal || "N/A"} | IC - ${data.itemGarmentCount
                        }  ) ${data.urgentDelivery ? " | U " : ""}  ${data.deliveryRequest ? " | H " : ""
                        }`}
                >
                    <div
                        className="cursor-pointer"
                        onClick={() =>
                            userRole === "BY_ADMIN" || userRole === "BY_SUB_ADMIN_USER"
                                ? navigate("/B2BOrdersGarmentInfo", {
                                    state: {
                                        storeIdValue: data.storeId,
                                        bookingOrderId: data.id,
                                        storeCustomerId: data.storeCustomerId,
                                        navigateThrough: "GoBack",
                                    },
                                })
                                : navigate("/B2BOrdersGarmentInfo", {
                                    state: {
                                        bookingOrderId: data.id,
                                        storeCustomerId: data.storeCustomerId,
                                        navigateThrough: "GoBack",
                                    },
                                })
                        }
                    >
                        <div className="flex-row">
                            <div className="col-4">
                                <p className="text-base font-semiBold capitalize">
                                    Challan No:
                                </p>
                                <p className="text-lg font-bold capitalize">
                                    {data.challanNo || "N/A"}
                                </p>
                            </div>
                            <div className="col-4">
                                <p className="text-base font-semiBold capitalize">
                                    Order Source:
                                </p>
                                <p className="text-lg font-bold capitalize">
                                    {data.orderSource
                                        ? data.orderSource.replace(/_/g, " ")
                                        : "N/A"}
                                </p>
                            </div>
                            <div className="col-4">
                                <p className="text-base font-semiBold capitalize">Status:</p>
                                <p className="text-lg font-bold capitalize">
                                    <span style={{ color: orderStatusColor }}>
                                        {data.status || "Unknown"}
                                    </span>
                                </p>
                            </div>
                        </div>

                        <div className="flex-row">
                            <div className="col-4">
                                <p className="text-base font-semiBold capitalize">
                                    Customer Name:
                                </p>
                                <p className="text-lg font-bold capitalize">
                                    {data.customerName || "N/A"}
                                </p>
                            </div>
                            <div className="col-4">
                                <p className="text-base font-semiBold capitalize">
                                    Customer Mobile No.:
                                </p>
                                <p className="text-lg font-bold capitalize">
                                    {data.customerMobile || "N/A"}
                                </p>
                            </div>
                            <div className="col-4">
                                <p className="text-base font-semiBold capitalize">Remarks:</p>
                                <p className="text-lg font-bold capitalize">
                                    {data.remarks || "N/A"}
                                </p>
                            </div>
                        </div>

                        <div className="flex-row">
                            <div className="col-4">
                                <p className="text-base font-semiBold capitalize">
                                    {displayDeliveryDateText}:
                                </p>
                                <p className="text-lg font-bold capitalize">
                                    {formattedDeliveryDate}
                                </p>
                            </div>
                            <div className="col-4">
                                <p className="text-base font-semiBold capitalize">
                                    Challan {displayBalanceText} Amount:
                                </p>
                                <p className="text-lg font-bold capitalize">
                                    {data.grandTotal} {displayBalanceAmount}
                                </p>
                            </div>
                           
                        </div>

                        <div className="flex-row">
                            <div className="col-8">
                                <p className="text-base font-semiBold capitalize">Address:</p>
                                <p className="text-lg font-bold capitalize">
                                    {data.customerAddress}
                                </p>
                            </div>
                            {data.deliveryRemarks && (
                                <div className="col-4">
                                    <p className="text-base font-semiBold capitalize">
                                        Delivery Remark:
                                    </p>
                                    <p className="text-lg font-bold capitalize">
                                        {data.deliveryRemarks}
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>
                </AccordionTab>
            </Accordion>
        );
    };

    // const footer = (
    //   <Button
    //     type="text"
    //     icon="pi pi-plus"
    //     label="Load"
    //     onClick={getData} // Update this to trigger `getData`
    //   />
    // );
    const [tabularView, setTabularView] = useState(false);

    const handleTabListViewChange = async (selectedType) => {
        setTabularView(selectedType);
        await setSelectedTabListView(selectedType);
    };

    const fetchSelectedTabListView = async () => {
        try {
            const selectedInvoiceTypeData = await getSelectedTabListView();
            setTabularView(selectedInvoiceTypeData?.tabListView || "list");
        } catch {
            setTabularView("list");
        }
    };

    const PcsBodyTemplate = (rowData) => {
        return (
            <div
                style={{ backgroundColor: "#09B4AA" }}
                className="px-2 border-round-md cursor-pointer"
            >
                <span className="text-white text-lg font-bold uppercase">
                    {rowData.itemGarmentCount}
                </span>
            </div>
        );
    };

    const statusBodyTemplate = (rowData) => {
        return (
            <div
                className="flex flex-row justify-content-between cursor-pointer"
            >
                <span style={{ color: OrderStatusColors[rowData.status] }}>
                    {rowData?.status?.replace(/_/g, " ")}
                </span>
                 
            </div>
        );
    };

    const invoiceBodyTemplate = (rowData) => {
        return (
            <div
                className="cursor-pointer"
                onClick={() =>
                    userRole === "BY_ADMIN" || userRole === "BY_SUB_ADMIN_USER"
                        ? navigate("/B2BOrdersGarmentInfo", {
                            state: {
                                storeIdValue: rowData.storeId,
                                bookingOrderId: rowData.id,
                                storeCustomerId: rowData.storeCustomerId,
                                navigateThrough: "GoBack",
                            },
                        })
                        : navigate("/B2BOrdersGarmentInfo", {
                            state: {
                                bookingOrderId: rowData.id,
                                storeCustomerId: rowData.storeCustomerId,
                                navigateThrough: "GoBack",
                            },
                        })
                }
            >
                <span style={{ color: "blue", textDecoration: "underline" }}>
                    {rowData?.challanNo}
                </span>
            </div>
        );
    };

    const RenderTabView = () => {
        return (
            <DataTable
                showGridlines
                value={customerALLOrdersData}
                // header={header}
                paginator
                rows={100}
                rowsPerPageOptions={[50, 100]}
                tableStyle={{ minWidth: "120rem" }}
                stripedRows
                scrollable
                scrollHeight={height - 260}
            >
                <Column
                    field="challanNo"
                    header="Challan No"
                    style={{ width: "130px" }}
                    body={invoiceBodyTemplate}
                ></Column>
                <Column
                    field="createdDate"
                    header="Booking Date"
                    style={{ width: "130px" }}
                    body={(rowData) => formatDateNew(rowData?.createdDate)}
                />
                <Column
                    field="deliveryOn"
                    header="Due Date"
                    style={{ width: "150px" }}
                    body={(rowData) =>
                        rowData.status === "DELIVERED" || rowData.status === "DONE"
                            ? formatDateNew(rowData.deliveredOn)
                            : formatDateNew(rowData.deliveryOn)
                    }
                ></Column>
                <Column
                    field="customerName"
                    header="Customer Name"
                    style={{ width: "180px" }}
                    body={(rowData) => rowData?.customerName?.replace(/_/g, " ")}
                ></Column>
                <Column
                    field="customerMobile"
                    header="Mobile"
                    style={{ width: "100px" }}
                    body={(rowData) => rowData?.customerMobile?.replace(/_/g, " ")}
                ></Column>
                <Column
                    field="status"
                    header="Status"
                    style={{ width: "120px" }}
                    body={statusBodyTemplate}
                ></Column>
                
                <Column
                    field="itemGarmentCount"
                    header="Pcs"
                    style={{ width: "50px" }}
                    // body={(rowData) => rowData?.itemGarmentCount}
                    body={PcsBodyTemplate}
                ></Column>
                <Column
                    field="grandTotal"
                    header="Amount"
                    style={{ width: "100px" }}
                ></Column>
                <Column
                    field="balanceAmount"
                    header="Balance"
                    style={{ width: "100px" }}
                ></Column>
                 
                <Column
                    field="orderSource"
                    header="Order Source"
                    style={{ width: "120px" }}
                    body={(rowData) => rowData?.orderSource?.replace(/_/g, " ")}
                ></Column>
                <Column field="remarks" header="Remarks"></Column>
            </DataTable>
        );
    };

    const filterData = (data, searchTerm) => {
        if (!searchTerm) return data; // Return full data if search is empty

        const searchLower = searchTerm.toLowerCase();

        return data.filter((item) =>
            Object.values(item).some((value) =>
                typeof value === "string" || typeof value === "number"
                    ? value.toString().toLowerCase().includes(searchLower)
                    : false
            )
        );
    };

    const filteredOrderInfoData = filterData(customerALLOrdersData, searchTerm);

    const exportExcel = () => {
        import("xlsx").then((xlsx) => {
            // Map only the required fields for export
            const exportData = filteredOrderInfoData.map((item) => ({
                "Challan No": item.challanNo,
                "Booking Date": formatDateNew(item.createdDate),
                "Due Date":
                    item.status === "DELIVERED" || item.status === "DONE"
                        ? formatDateNew(item.deliveredOn)
                        : formatDateNew(item.deliveryOn),
                "Customer Name": item.customerName?.replace(/_/g, " "),
                Mobile: item.customerMobile,
                Status: item.status?.replace(/_/g, " "),
                Pcs: item.itemGarmentCount,
                Amount: item.grandTotal,
                Balance: item.balanceAmount,
                "Order Source": item.orderSource?.replace(/_/g, " "),
                Remarks: item.remarks,
            }));

            const worksheet = xlsx.utils.json_to_sheet(exportData);
            const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
            const excelBuffer = xlsx.write(workbook, {
                bookType: "xlsx",
                type: "array",
            });

            saveAsExcelFile(excelBuffer, "My_Challan");
        });
    };

    const saveAsExcelFile = (buffer, fileName) => {
        import("file-saver").then((module) => {
            if (module && module.default) {
                let EXCEL_TYPE =
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                let EXCEL_EXTENSION = ".xlsx";
                const data = new Blob([buffer], {
                    type: EXCEL_TYPE,
                });

                module.default.saveAs(
                    data,
                    fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
                );
            }
        });
    };

    return (
        <div className="flex-1">
            <div
                className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
                style={{
                    "--surface-0": "#1752AA",
                }}
            >
                <div className="flex-1 flex ml-3 mr-3">
                    <div className="flex-1 flex ">
                        <div className="ml-3 flex justify-content-center align-items-center">
                            <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                                <i
                                    className="pi pi-angle-left"
                                    onClick={() => navigate("/")}
                                    style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                                ></i>
                            </div>
                        </div>
                        <div className="flex-1 ml-5">
                            <p className="text-white text-2xl font-bold uppercase">
                                All B2B Challan
                            </p>
                        </div>
                    </div>
                    <div className="flex justify-content-center align-items-center">
                        <div className="flex justify-content-center align-items-center cursor-pointer mx-2">
                            <img
                                onClick={exportExcel}
                                src={"images/file.png"}
                                style={{
                                    width: 30,
                                }}
                            />
                        </div>
                    </div>
                    <div
                        className="flex justify-content-center align-items-center cursor-pointer"
                        onClick={() => {
                            tabularView !== "tab"
                                ? handleTabListViewChange("tab")
                                : handleTabListViewChange("list");
                        }}
                    >
                        <div
                            className="px-3 py-1 cursor-pointer"
                            style={{
                                backgroundColor: "#55BD5A",
                                borderRadius: 5,
                                marginRight: 20,
                            }}
                        >
                            <p className=" text-lg text-white font-medium capitalize">
                                {tabularView !== "tab" ? "Tab View" : "List View"}
                            </p>
                        </div>
                    </div>
                    <div
                        onClick={() => handleCalendarModal()}
                        className="mx-2 cursor-pointer"
                    >
                        <img
                            src={"Laundy_App_Icons_Gifs/Other_Icons/schedule.png"}
                            style={{ width: 27 }}
                        />
                    </div>

                    <div
                        onClick={() => handleFilterModal("DELIVERED")}
                        className="mx-2 cursor-pointer"
                    >
                        <img
                            src={"Laundy_App_Icons_Gifs/Other_Icons/filter.png"}
                            style={{ width: 27 }}
                        />
                    </div>

                    <div
                        onClick={() => setStoreSelectionModalVisible(true)}
                        className="mx-2 cursor-pointer"
                    >
                        <img
                            src={"Laundy_App_Icons_Gifs/Other_Icons/filter.png"}
                            style={{ width: 27 }}
                        />
                    </div>
                    <div
                        className="flex justify-content-center align-items-center cursor-pointer"
                        onClick={() => setVisible(true)}
                    >
                        <i
                            className="pi pi-bars"
                            style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
                        ></i>
                    </div>
                </div>
            </div>

            <div className="  my-2">
                {customerALLOrdersData.length > 0 && (
                    <div
                        className="flex gap-3 mb-3 mx-4 pb-1 new-scroll-bar"
                        style={{
                            overflowX: "auto",
                            whiteSpace: "nowrap",
                        }}
                    >
                        <div
                            style={{ backgroundColor: "#2B70D7" }}
                            className="px-3 py-2 border-round-md"
                        >
                            <p className="text-white text-lg font-bold uppercase">
                                {sumOfOrderCount} - All ({storeLocalData?.currencySymbol} {sumOfGrandTotal.toFixed(0)})
                            </p>
                        </div>

                        {renderPaymentModeButtons()}
                    </div>
                )}

                <div className="my-2 mx-5 flex flex-1">
                    <div className="flex-1">
                        <IconField iconPosition="left" className="flex flex-1">
                            <InputIcon className="pi pi-search text-xl"> </InputIcon>
                            <InputText
                                placeholder={
                                    searchFilterValue === "challan"
                                        ? "Search By Challan No."
                                        : searchFilterValue === "order"
                                            ? "Search By Order No."
                                            : "Search By Invoice No."
                                }
                                value={searchTerm}
                                keyboardType={
                                    searchFilterValue === "NAME" ? "default" : "numeric"
                                }
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="text-xl flex flex-1 py-1 px-5"
                                style={{ borderRadius: 30 }}
                            />
                        </IconField>
                    </div>

                    {searchTerm ? (
                        <div class="flex mx-2 gap-3">
                            <div
                                style={{ backgroundColor: "#2B70D7" }}
                                className="px-3 py-2 border-round-md cursor-pointer"
                                onClick={() => searchTermApiCall()}
                            >
                                <p className="text-white text-lg font-bold uppercase">Search</p>
                            </div>
                            <div
                                style={{ backgroundColor: "#d72b2bff" }}
                                className="px-3 border-round-md cursor-pointer"
                                onClick={handleClearSearch}
                            >
                                <p className="text-4xl font-bold " style={{ color: "#fff" }}>
                                    {" "}
                                    X
                                </p>
                            </div>
                        </div>
                    ) : (
                        <div
                            onClick={handleSearchType}
                            className="flex justify-content-center align-items-center mx-2 cursor-pointer"
                        >
                            <div>
                                <img
                                    src={"Laundy_App_Icons_Gifs/Other_Icons/filter.png"}
                                    style={{ width: 27 }}
                                />
                            </div>
                        </div>
                    )}
                </div>
                {searchTypeToggle && (
                    <div className="flex-1 mx-5 mb-4">
                        <Dropdown
                            value={searchFilterValue}
                            onChange={(e) => handleSearchFilterChange(e.value)}
                            options={FilterList}
                            optionLabel="name"
                            placeholder="Search Filter"
                            className="w-full  bg-white-alpha-20 border-round-lg p-0 text-lg text-primary-50"
                        />
                    </div>
                )}
                {loadingSearch || loading ? (
                    <div style={{ flex: 1 }}>
                        <div className="text-center">
                            <ProgressSpinner
                                style={{ width: "70px", height: "70px" }}
                                strokeWidth="4"
                                fill="var(--surface-ground)"
                                animationDuration="2s"
                            />
                        </div>
                    </div>
                ) : customerALLOrdersData?.length > 0 ? (
                    <div>
                        <div>
                            {tabularView === "tab" && (
                                <div
                                    className="scroll-bar mb-2"
                                >
                                    <div className="mx-4 report-table">
                                        <div className="tab-view-table">{RenderTabView()}</div>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div style={{ display: tabularView === "tab" ? "none" : "" }}>
                            <DataScroller
                                value={customerALLOrdersData}
                                itemTemplate={itemTemplate}
                                rows={customerALLOrdersData?.length + 100}
                                inline
                                ref={ds}
                                scrollHeight={height - 220}
                                loader
                            // footer={footer}
                            />
                        </div>
                    </div>
                ) : (
                    <div className="flex justify-content-center align-items-center">
                        <p className="text-xl font-semi-bold">No Order Found</p>
                    </div>
                )}

                <div
                    className="flex justify-content-center fixed "
                    style={{ bottom: 80, left: 20 }}
                >
                    <Button
                        type="text"
                        icon="pi pi-plus"
                        // label="More"
                        onClick={getData} // Update this to trigger `getData`
                    />
                </div>

                <TabMenu />

                <SchedularModal
                    setSchedularModalVisible={setSchedularModalVisible}
                    schedularModalVisible={schedularModalVisible}
                    sendDataToOrdersPage={receiveDataFromSchedularModal}
                />
                <StatusFilterModal
                    setStatusFilterModalVisible={setStatusFilterModalVisible}
                    statusFilterModalVisible={statusFilterModalVisible}
                    sendDataToOrdersPageFromFilter={receiveDataFromStatusFilterModal}
                    upDateSelectedStatus={upDateSelectedStatus}
                    OrderStatus={['BOOKED',
                        'PROCESSED',
                        'DELIVERED',
                        'ORDERED',
                        'CANCEL']}
                />
                <StoreSelectionModal
                    setStoreSelectionModalVisible={setStoreSelectionModalVisible}
                    storeSelectionModalVisible={storeSelectionModalVisible}
                    sendDataToOrdersPageFromFilter={receiveDataFromStoreSelectionModal}
                    upDateSelectedStore={upDateSelectedStore}
                    brandStoreData={brandStoreData}
                />
                <AdminMenu setVisible={setVisible} visible={visible} />
                <ButtonLink />
            </div>
        </div>
    );
};

export default Orders;
